import React from "react";
import {
  Step,
  StepLabel,
  Stepper,
  StepperProps,
  StepLabelProps,
  StepIconProps,
} from "@mui/material";
import styled from "@emotion/styled";
import CircleCheck from "./icons/CircleCheckIcon";

export type TextStep = { label: string; icon: React.ReactNode };

export type SteppersProps = Omit<StepperProps, "children"> & {
  steps: TextStep[];
  activeStep: number;
};

const StyledStepper = styled(Stepper)<StepperProps>`
  background-color: unset;
  align-items: unset;

  .MuiStepIcon-root {
    width: 32px;
    height: 32px;
    color: hsl(var(--color-primary-200));
  }
  .MuiStep-horizontal {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90px;
  }
  .MuiStepLabel-iconContainer {
    padding: 0;
  }
  .MuiStepIcon-text {
    font-size: 10px;
    font-weight: 600;
    font-style: normal;
    line-height: 16px;
    text-align: center;
    fill: hsl(var(--color-primary));
  }

  .MuiStepConnector-line {
    display: flex;
    border-color: hsl(var(--color-primary-300));
    border-top-width: 2px;
    width: 75px;
    margin: 20px -20px;
  }
`;

const PromoIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ ownerState }) => ({
  backgroundColor: "hsl(var(--color-white))",
  zIndex: 1,
  color: "hsl(var(--color-primary-300))",
  width: 40,
  height: 40,
  display: "flex",
  border: "2px solid",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.completed && {
    color: "hsl(var(--color-secondary))",
  }),
  "& .PromoIcon-completedIcon": {
    width: 40,
    height: 40,
  },
}));

const promoStepIcons = (icon: React.ReactNode) =>
  function promoIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    return (
      <PromoIconRoot ownerState={{ completed, active }} className={className}>
        {completed ? <CircleCheck className="PromoIcon-completedIcon" /> : icon}
      </PromoIconRoot>
    );
  };

// hack to stop prop forwarding of step component to children
const StepContainer = ({ children }: StepLabelProps) => {
  return <>{children}</>;
};

const TextStepper = ({ steps, activeStep }: SteppersProps) => (
  <StyledStepper activeStep={activeStep}>
    {steps.map(({ label, icon }, i) => (
      <Step key={label} aria-current={activeStep - 1 === i ? "step" : false}>
        <StepLabel StepIconComponent={promoStepIcons(icon)} />
        <StepContainer>
          <div className="whitespace-nowrap">
            <div className="body pt-1 text-xs">{label}</div>
          </div>
        </StepContainer>
      </Step>
    ))}
  </StyledStepper>
);
export default TextStepper;
